/*
 * Calmont Popup vor der Kasse (Theme-Einstellungen › Calmont Warenkorb › „Popup vor der Kasse“).
 * Beim Klick auf „Zur Kasse“: liegt ein Auslöser-Produkt im Warenkorb, das Angebot aber nicht, erscheint einmal je Sitzung
 * das Angebot (ausführlich mit Größenwahl oder kompakt). Zeilen der Zuordnung: „auslöser-handle > angebot-handle × menge | Überschrift | Hinweis“.
 */
(() => {
  const C = window.CalXU; if (!C) return;
  C.rules = C.rules || []; C.atc = C.atc || [];
  if (!C.rules.length && !C.atc.length) return;
  // A/B-Test (ABlyft): ist „nur per ABlyft“ eingestellt, zeigt das Popup nur, wenn die Variante window.CalXUAb = 'ausfuehrlich' | 'kompakt' setzt
  const abStyle = () => (C.ab ? (window.CalXUAb === 'ausfuehrlich' || window.CalXUAb === 'kompakt' ? window.CalXUAb : null) : C.style);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const fmt = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = (t) => String(t == null ? '' : t).replace(/ %/g, '\u00a0%').replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  let busy = false;

  // Angebots-Produkt (und Bild) vorab laden, sobald der Warenkorb einen Auslöser enthält – der Klick auf „Zur Kasse“ öffnet dann sofort
  const cache = {};
  const prod = (h) => (cache[h] = cache[h] || fetch(root + 'products/' + h + '.js').then((x) => (x.ok ? x.json() : null)).catch(() => null));
  const seen = (h) => { try { return !!sessionStorage.getItem('calXU:' + h); } catch (e) { return false; } };
  const match = (handles) => { const have = new Set(handles); return C.rules.filter((r) => have.has(r.trigger) && !have.has(r.offer) && !seen(r.offer)); };
  const warm = () => {
    if (!abStyle() || !window.CalCartHandles) return;
    match(window.CalCartHandles).forEach((r) => prod(r.offer).then((p) => { if (p && p.featured_image) { const i = new Image(); i.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=400'; } }));
  };
  document.addEventListener('cal:cart-sub', warm);
  setTimeout(warm, 2500);

  async function pick() {
    // Warenkorb-Inhalt hält assets/cal-cart.js nach jeder Änderung aktuell (window.CalCartHandles); sonst einmal abfragen
    const handles = window.CalCartHandles || (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())).items.map((i) => i.handle);
    for (const r of match(handles)) {
      const p = await prod(r.offer);
      if (p && p.variants.some((v) => v.available)) return { r, p };
    }
    return null;
  }

  function unit(r, v) {
    const ref = Math.max(v.price, v.compare_at_price || 0);
    const bon = r.bonus && C.bonus ? v.price - Math.floor(v.price * C.bonus / 100) : v.price;
    return { price: bon, ref };
  }

  function open({ r, p }, go, atc) {
    // atc: Popup direkt nach „In den Warenkorb“ (window.CalXUAfterAdd) – immer ausführlich, mit Haken-Zeile und Punkten
    try { sessionStorage.setItem((atc ? 'calXUa:' : 'calXU:') + r.offer, '1'); } catch (e) {}
    const full = atc ? true : abStyle() !== 'kompakt';
    const ev = atc ? 'atc_popup' : 'kassen_popup';
    const sel = (p.variants.find((v) => v.available) || p.variants[0]).options.slice();
    const hasOpts = p.options.length && !(p.options.length === 1 && p.options[0].name === 'Title');
    const dlg = document.createElement('dialog'); dlg.className = 'cal-xu' + (full ? '' : ' cal-xu--mini');
    const sz = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');
    const img = sz(p.featured_image, 400);
    // Variantenbilder wie in der Kaufbox: Werte einer Option mit eigenem Bild bekommen ein kleines Vorschaubild
    const vimg = (i, val) => { const v = p.variants.find((x) => x.options[i] === val && x.featured_image); return v ? v.featured_image.src : ''; };
    const thumbs = p.options.map((o, i) => new Set(o.values.map((val) => vimg(i, val))).size > 1);
    // Icons aus der Kaufbox (Vorlage in snippets/cal-head.liquid), sonst Variantenbild, sonst Text
    const tpl = document.querySelector('template[data-cal-xu-oi="' + (window.CSS && CSS.escape ? CSS.escape(r.offer) : r.offer) + '"]');
    const oi = (i, val) => { if (!tpl) return ''; const el = [...tpl.content.querySelectorAll('[data-o="' + i + '"]')].find((x) => x.getAttribute('data-v') === val); return el && el.querySelector('.cal-oi-w') ? el.innerHTML : ''; };
    const icons = p.options.map((o, i) => o.values.every((val) => oi(i, val)));
    const chip = (i, v) => icons[i]
      ? `<button type="button" class="cal-xu__chip cal-xu__oc" data-o="${i}" data-v="${esc(v)}">${oi(i, v)}</button>`
      : `<button type="button" class="cal-xu__chip${thumbs[i] ? ' cal-xu__chip--img' : ''}" data-o="${i}" data-v="${esc(v)}">${thumbs[i] ? `<img src="${esc(sz(vimg(i, v), 120))}" alt="" loading="eager">` : ''}<span>${esc(v)}</span></button>`;
    dlg.innerHTML = `<div class="cal-xu__box">
      <div class="cal-xu__grip" aria-hidden="true"></div>
      ${atc && atc.added ? `<p class="cal-xu__ok"><i></i>${esc(atc.added)} liegt im Warenkorb</p>` : ''}
      <div class="cal-xu__h"><div>${atc ? '' : `<p class="cal-xu__k">${esc(C.kicker)}</p>`}<h3>${esc(r.title || ('Passt dazu: ' + p.title))}</h3></div><button type="button" class="cal-xu__x" data-x aria-label="Schließen"><svg class="cal-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>
      ${atc && r.points && r.points.length ? `<ul class="cal-xu__pts">${r.points.filter(Boolean).map((x) => `<li>${esc(x)}</li>`).join('')}</ul>` : ''}
      <div class="cal-xu__item"><img src="${esc(img)}" alt="">
        <div><span class="cal-xu__badge" data-badge hidden></span><b>${r.qty > 1 ? r.qty + ' × ' : ''}${esc(p.title)}</b>
        <span class="cal-xu__price"><span data-p></span><s data-c></s><em data-s></em></span></div>
        ${full ? '' : '<button type="button" class="cal-xu__add" data-add>+ Dazu</button>'}</div>
      ${hasOpts ? '<div class="cal-xu__opts"' + (full ? '' : ' hidden') + '>' + p.options.map((o, i) => `<div class="cal-xu__row"><span>${esc(o.name)}: <b data-ol="${i}"></b></span><div>${o.values.map((v) => chip(i, v)).join('')}</div></div>`).join('') + '</div>' : ''}
      ${full && r.note ? `<p class="cal-xu__note">${esc(r.note)}</p>` : ''}
      <div class="cal-xu__btns">${full ? '<button type="button" class="cal-xu__go" data-add></button>' : (hasOpts ? '<button type="button" class="cal-xu__go" data-add hidden></button>' : '')}<button type="button" class="cal-xu__skip" data-skip>${atc ? 'Nein danke, weiter' : 'Nein danke, weiter zur Kasse'}</button></div>
      <p class="cal-xu__msg" data-msg hidden></p></div>`;
    document.body.append(dlg);
    const cur = () => p.variants.find((v) => v.options.every((x, i) => x === sel[i]));
    const upd = () => {
      const v = cur(); const ok = v && v.available;
      dlg.querySelectorAll('[data-o]').forEach((b) => {
        b.setAttribute('aria-pressed', String(sel[+b.dataset.o] === b.dataset.v));
        const t = sel.slice(); t[+b.dataset.o] = b.dataset.v; const tv = p.variants.find((x) => x.options.every((y, i) => y === t[i]));
        b.disabled = !tv || !tv.available;
      });
      dlg.querySelectorAll('[data-ol]').forEach((el) => { el.textContent = String(sel[+el.dataset.ol] || '').replace(/\s*\(.*\)\s*$/, ''); });
      if (!v) return;
      const im = dlg.querySelector('.cal-xu__item img');
      const want = sz(v.featured_image ? v.featured_image.src : p.featured_image, 400);
      if (im && want && im.getAttribute('src') !== want) { im.classList.add('is-swap'); const n = new Image(); n.onload = () => { im.src = want; im.classList.remove('is-swap'); }; n.src = want; }
      const u = unit(r, v); const q = r.qty || 1; const pct = u.ref > u.price ? Math.round((u.ref - u.price) / u.ref * 100) : 0;
      dlg.querySelector('[data-p]').textContent = fmt(u.price * q);
      const c = dlg.querySelector('[data-c]'); c.textContent = pct ? fmt(u.ref * q) : ''; c.hidden = !pct;
      const s = dlg.querySelector('[data-s]'); s.textContent = pct ? 'Du sparst ' + pct + ' %' : ''; s.hidden = !pct;
      const b = dlg.querySelector('[data-badge]'); if (C.name && pct) { b.textContent = C.name + ' −' + pct + ' %'; b.hidden = false; }
      const g = dlg.querySelector('.cal-xu__go'); if (g) { g.textContent = ok ? 'Hinzufügen · ' + fmt(u.price * q) : 'Nicht verfügbar'; g.disabled = !ok; }
      const a = dlg.querySelector('.cal-xu__add'); if (a) a.disabled = !ok;
    };
    upd();
    const shut = (then) => {
      if (dlg.classList.contains('is-out')) return;
      dlg.classList.add('is-out');
      const end = () => { dlg.close(); dlg.remove(); if (then) then(); };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) end(); else setTimeout(end, 220);
    };
    const done = () => shut(go);
    dlg.addEventListener('click', async (e) => {
      const t = e.target.closest('button'); if (e.target === dlg) { shut(atc ? go : null); return; }
      if (!t) return;
      if (t.dataset.x !== undefined) { shut(atc ? go : null); return; }
      if (t.dataset.o !== undefined) { sel[+t.dataset.o] = t.dataset.v; upd(); return; }
      if (t.dataset.skip !== undefined) { try { if (window.calTrack) window.calTrack(ev + '_nein', { produkt: r.offer }); } catch (er) {} done(); return; }
      if (t.dataset.add !== undefined) {
        // Kompakt mit Varianten: erst Größe & Co. aufklappen, dann mit dem großen Knopf hinzufügen
        if (!full && hasOpts && t.classList.contains('cal-xu__add')) { dlg.querySelector('.cal-xu__opts').hidden = false; dlg.querySelector('.cal-xu__go').hidden = false; t.hidden = true; return; }
        const v = cur(); if (!v || !v.available) return;
        t.disabled = true;
        const item = { id: v.id, quantity: r.qty || 1, properties: { _quelle: atc ? 'atc-popup' : 'kassen-popup' } };
        let ok = true;
        if (atc && window.calCartAdd) {
          // Drawer gleich mit dem Bezug neu zeichnen (Horizon-Ereignis über assets/cal-cart.js)
          try { await window.calCartAdd(t, [item]); } catch (er) { ok = false; }
        } else {
          window.__calAdding = true;
          const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
          window.__calAdding = false;
          ok = res.ok;
        }
        if (!ok) { const m = dlg.querySelector('[data-msg]'); m.hidden = false; m.textContent = 'Das hat leider nicht geklappt.'; t.disabled = false; return; }
        try { if (window.calTrack) window.calTrack(ev + '_hinzu', { produkt: r.offer, stil: full ? 'ausfuehrlich' : 'kompakt' }); } catch (er) {}
        // Geschenk (ab Bestellwert) vor dem Weg zur Kasse prüfen, sonst fehlt es dort
        try { if (window.calGiftCheck) await Promise.race([window.calGiftCheck(), new Promise((ok) => setTimeout(ok, 4000))]); } catch (er) {}
        done();
      }
    });
    dlg.addEventListener('cancel', (e2) => { e2.preventDefault(); shut(atc ? go : null); });
    dlg.tabIndex = -1;
    dlg.showModal();
    dlg.focus(); // kein Fokusrahmen am Schließen-Knopf beim Öffnen
    try { if (window.calTrack) window.calTrack(ev + '_gezeigt', { produkt: r.offer, stil: full ? 'ausfuehrlich' : 'kompakt' }); } catch (e) {}
  }

  // Popup direkt nach „In den Warenkorb“ (Kaufbox, assets/cal-buy.js): true = Popup offen, go() öffnet danach den Warenkorb
  const pageHandle = (location.pathname.split('/products/')[1] || '').split('/')[0];
  C.atc.filter((r) => r.trigger === pageHandle).forEach((r) => prod(r.offer)); // vorab laden
  window.CalXUAfterAdd = async (handle, cartHandles, go, added) => {
    if (!C.atc.length) return false;
    const have = new Set(cartHandles || window.CalCartHandles || []);
    for (const r of C.atc) {
      if (r.trigger !== handle || have.has(r.offer)) continue;
      try { if (sessionStorage.getItem('calXUa:' + r.offer)) continue; } catch (e) {}
      const p = await prod(r.offer);
      if (p && p.variants.some((v) => v.available)) { open({ r, p }, go, { added }); return true; }
    }
    return false;
  };

  document.addEventListener('click', async (e) => {
    const b = e.target instanceof Element ? e.target.closest('button[name="checkout"], a[href$="/checkout"], [data-cal-checkout]') : null;
    if (!b || busy || b.dataset.calXuPass) return;
    if (!abStyle()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    busy = true;
    const go = () => { busy = false; b.dataset.calXuPass = '1'; if (b.form && b.name === 'checkout') { const i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1'; b.form.append(i); b.form.submit(); } else window.location.href = root + 'checkout'; };
    try { const hit = await pick(); if (hit) { busy = false; open(hit, go); } else go(); } catch (er) { go(); }
  }, true);
})();
